import {PipeTransform, Pipe} from '@angular/core';
import {isString, isBlank} from '../facade/lang';
import {InvalidPipeArgumentException} from './invalid_pipe_argument_exception';
export class LowerCasePipe implements PipeTransform {
  transform(value: string): string {
    if (isBlank(value)) return value;
    if (!isString(value)) {
      throw new InvalidPipeArgumentException(LowerCasePipe, value);
    }
    return value.toLowerCase();
  }
static decorators: DecoratorInvocation[] = [
{ type: Pipe, args: [{name: 'lowercase'}, ] },
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
